import React, { useContext, useState } from "react";
import {
  Button,
  Label,
  Table,
  Menu,
  Icon,
  Container,
  Confirm,
  List,
} from "semantic-ui-react";
import ProjectTimeStore from "../../../app/stores/projecttimeStore";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";

const ProjectTimeList: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [projecttimeId, setProjectTimeId] = useState("");
  const projecttimeStore = useContext(ProjectTimeStore);
  const {
    projecttimesByName: projecttimesByName,
    deleteProjectTime: deleteProjectTime,
    employeeRegistry,
    submitting,
    target,
  } = projecttimeStore;

  return (
    <Container fluid>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Project Code</Table.HeaderCell>
            <Table.HeaderCell>Description</Table.HeaderCell>
            <Table.HeaderCell>Type</Table.HeaderCell>
            <Table.HeaderCell>Start Time</Table.HeaderCell>
            <Table.HeaderCell>End Time</Table.HeaderCell>
            <Table.HeaderCell>Lunch Time</Table.HeaderCell>
            <Table.HeaderCell>Overtime Rate</Table.HeaderCell>
            <Table.HeaderCell>Weekend Rate</Table.HeaderCell>
            <Table.HeaderCell>Night Shift Rate</Table.HeaderCell>
            <Table.HeaderCell>Reviewer</Table.HeaderCell>
            <Table.HeaderCell>Remark</Table.HeaderCell>
            <Table.HeaderCell width={1}>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {projecttimesByName.map((projecttime) => (
            <Table.Row key={projecttime.id}>
              <Table.Cell>
                <strong>{projecttime.code}</strong>
              </Table.Cell>
              <Table.Cell>{projecttime.description}</Table.Cell>
              <Table.Cell>{projecttime.type}</Table.Cell>
              <Table.Cell>{projecttime.startTime}</Table.Cell>
              <Table.Cell>{projecttime.endTime}</Table.Cell>
              <Table.Cell>{projecttime.lunch} minutes</Table.Cell>
              <Table.Cell>{projecttime.penaltyRate}</Table.Cell>
              <Table.Cell>{projecttime.weekendRate}</Table.Cell>
              <Table.Cell>{projecttime.nightRate}</Table.Cell>
              <Table.Cell>{(employeeRegistry.get(projecttime.reviewerEmail)) ? 
              (employeeRegistry.get(projecttime.reviewerEmail)).name : ''}</Table.Cell>
              <Table.Cell>{projecttime.remark}</Table.Cell>
              <Table.Cell>
                <Button.Group size="mini">
                <Button
                    as={Link}
                    to={`/hrmanagement/projecttimes-edit/${projecttime.id}`}
                    size="mini"
                    icon="edit"
                    color="yellow"
                    title="Edit"
                  />
                  <Button
                    name={projecttime.id}
                    size="mini"
                    loading={target === projecttime.id && submitting}
                    onClick={() => {
                      setOpen(true);
                      setProjectTimeId(projecttime.id);
                    }}
                    icon="delete"
                    color="red"
                    title="Delete"
                  />
                  <Confirm
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={(e) => {
                      deleteProjectTime(projecttimeId);
                      setOpen(false);
                    }}
                    content="Are you sure you want to delete ?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                      position: "relative",
                      maxHeight: "150px",
                      height: "auto",
                    }}
                  />
                </Button.Group>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Container>
  );
};

export default observer(ProjectTimeList);
